import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFirebase } from '../contexts/FirebaseContext';
import { useUser } from '../contexts/UserContext';
import AccountRecovery, { AuthLoading } from './AccountRecovery';

const AuthGuard = ({ children }) => {
  const { user, loading, error } = useFirebase();
  const { profileStatus } = useUser();
  if (loading || profileStatus === 'loading') return <AuthLoading />;
  if (error) return <AccountRecovery />;
  if (!user) return <Navigate to="/" replace />;
  if (profileStatus === 'error') return <AccountRecovery />;
  if (profileStatus === 'missing' || profileStatus === 'incomplete') {
    return <Navigate to="/register?step=2" replace />;
  }
  return children;
};
export default AuthGuard;
